import { ArrowLeft, ArrowRight, ArrowDown } from "lucide-react";
import { Reveal } from "./Reveal";

const COLUMNS = [
  {
    icon: ArrowLeft,
    title: "YOUR COMPLETE RESET",
    body: "14-day whole-food meal plan + complete grocery list + simple foundational supplement protocol + hydration and lifestyle guidelines. No guessing what to eat or what to do.",
  },
  {
    icon: ArrowDown,
    title: "FUNCTIONAL HEALTH + DATA",
    body: "1:1 Funtional Health + GI assessments with me, before/after weight, measurements, photos and biofeedback. We look at energy, digestion, bloating, sleep, hunger, cravings and brain fog - not only the scale.",
  },
  {
    icon: ArrowRight,
    title: "DIRECT ACCESS TO ME",
    body: "Private challenge community, daily education + accountability, group Q&A and coaching directly with me throughout the reset. Walking + restorative yoga are your only assigned movement.",
  },
];

export default function WhatYouGet() {
  return (
    <section className="bg-[#FFFFFF] px-4 sm:px-8 lg:px-12 py-14 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-3xl">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-[#1B2FD8]">Zero Dollars. All In.</p>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B0B12] mt-4 leading-[1.02]">
            HERE'S WHAT YOU GET FOR <span className="italic text-[#1B2FD8]">$0</span>
          </h2>
        </Reveal>
        <div className="mt-10 sm:mt-14 grid md:grid-cols-3 gap-4 sm:gap-6">
          {COLUMNS.map((col, i) => (
            <Reveal key={col.title} delay={i * 0.12} className="h-full">
              <div data-testid={`what-you-get-column-${i}`} className="h-full bg-[#F3F3FA] rounded-3xl border border-[#E3E3F0] p-6 sm:p-8 flex flex-col hover:shadow-xl hover:shadow-[#1B2FD8]/10 hover:-translate-y-1.5 transition-all duration-300">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br from-[#4B2A9E] to-[#1B2FD8] text-[#FFFFFF] flex items-center justify-center">
                  <col.icon size={18} strokeWidth={2.5} />
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl text-[#0B0B12] mt-5 sm:mt-6 tracking-tight">{col.title}</h3>
                <p className="text-[#4A4A66] leading-relaxed mt-3 sm:mt-4 text-sm sm:text-base">{col.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
